import React from 'react';

// Trace diagonale bas-droite → haut-gauche + empreintes éparpillées
// Les paires left/right alternent avec un léger décalage latéral (marche naturelle)
const TRAIL: { left: string; top: string; size: number; rot: number; opacity: number; isLeft: boolean }[] = [
  // Trace principale — bas-droite → haut-gauche (9 paires)
  { left: '88%', top: '88%', size: 52, rot: -45, opacity: 0.18, isLeft: false },
  { left: '80%', top: '80%', size: 50, rot: -45, opacity: 0.17, isLeft: true  },
  { left: '73%', top: '71%', size: 48, rot: -45, opacity: 0.16, isLeft: false },
  { left: '65%', top: '63%', size: 46, rot: -45, opacity: 0.15, isLeft: true  },
  { left: '57%', top: '55%', size: 44, rot: -45, opacity: 0.14, isLeft: false },
  { left: '49%', top: '47%', size: 44, rot: -45, opacity: 0.13, isLeft: true  },
  { left: '41%', top: '39%', size: 42, rot: -45, opacity: 0.12, isLeft: false },
  { left: '33%', top: '31%', size: 40, rot: -45, opacity: 0.11, isLeft: true  },
  { left: '25%', top: '23%', size: 40, rot: -45, opacity: 0.10, isLeft: false },
  { left: '17%', top: '15%', size: 38, rot: -45, opacity: 0.09, isLeft: true  },
  { left: '9%',  top: '7%',  size: 36, rot: -45, opacity: 0.08, isLeft: false },
  // Empreintes éparses pour donner du volume
  { left: '3%',  top: '55%', size: 30, rot: 20,  opacity: 0.06, isLeft: true  },
  { left: '93%', top: '40%', size: 28, rot: -30, opacity: 0.05, isLeft: false },
  { left: '50%', top: '3%',  size: 25, rot: 10,  opacity: 0.05, isLeft: true  },
  { left: '60%', top: '92%', size: 32, rot: -15, opacity: 0.06, isLeft: false },
];

// Décalage latéral alterné pour simuler la marche (gauche légèrement à gauche, droite légèrement à droite)
const LATERAL_OFFSET = 3; // %

const PawsBackground: React.FC = () => (
  <div
    aria-hidden="true"
    className="fixed inset-0 pointer-events-none overflow-hidden"
    style={{ zIndex: 0 }}
  >
    {TRAIL.map((p, i) => {
      const lateralShift = i < 11
        ? (p.isLeft ? -LATERAL_OFFSET : LATERAL_OFFSET)
        : 0;
      const leftNum = parseFloat(p.left);
      const adjustedLeft = `${leftNum + lateralShift}%`;

      return (
        <img
          key={i}
          src={p.isLeft ? '/paw-left.webp' : '/paw-right.webp'}
          alt=""
          width={64}
          height={64}
          loading="lazy"
          draggable={false}
          style={{
            position: 'absolute',
            left: adjustedLeft,
            top: p.top,
            width: p.size,
            height: p.size,
            transform: `rotate(${p.rot}deg)`,
            filter: 'invert(1)',
            opacity: p.opacity,
            userSelect: 'none',
          }}
        />
      );
    })}

    {/* Dégradé subtil de profondeur */}
    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/20" />
  </div>
);

export default PawsBackground;
